module.exports = __webpack_public_path__ + "img/昊华气体有限公司.72964439.jpg";